import {
  routeState,
  storageSceneReducer,
  deviceStatusReducer,
  errorHandleReducer,
} from "./common.js";
import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { createHashHistory } from "history";
import usermsg from "./usermsg.js";
import users from "./users";
import login from "./login";
import {
  dashboardReducer,
  sessionReducer,
  scheduleReducer,
  RXReducer,
  TXReducer,
  connectionReducer,
  RXGroupReducer,
  VWReducer,
} from "./dashboard";
import {
  settingGeneralReducer,
  settingAnmsReducer,
  settingRedundancyReducer,
} from "./setting";

import userPermission from "./user&permissions";
import { locationReducer } from "./location.js";
import { tgroupReducer, virtualtxReducer } from "./tx.js";
import { profilelistReducer, schedulelistReducer } from "./profile&schedule";

import { productsReducer } from "./products.js";
const history = createHashHistory({ basename: "/" });

const rootReducer = combineReducers({
  routeState,
  errortype: errorHandleReducer,
  usermsg,
  users,
  login,
  settingGeneralReducer,
  settingAnmsReducer,
  settingRedundancyReducer,
  dashboard: dashboardReducer,
  session: sessionReducer,
  schedule: scheduleReducer,
  rx: RXReducer,
  tx: TXReducer,
  rgroups: RXGroupReducer,
  vws: VWReducer,
  connection: connectionReducer,
  users: userPermission.usersReducer,
  ugroups: userPermission.ugroupReducer,
  permissionInBatch: userPermission.permissionInBatchReducer,
  permissionInBatchTX: userPermission.permissionInBatchTXReducer,
  ugroupPerms: userPermission.permissionUgroupReducer,
  userPerms: userPermission.permissionUserReducer,
  location: locationReducer,
  tgroup: tgroupReducer,
  virtualTx: virtualtxReducer,
  profilelist: profilelistReducer,
  schedulelist: schedulelistReducer,
  scene: storageSceneReducer,
  status: deviceStatusReducer,
  products: productsReducer,
  router: connectRouter(history),
});

export default rootReducer;
